import React, { useEffect, useState } from 'react';
import { toast } from 'sonner';
import { Copy, Gift, Share2 } from 'lucide-react';
import { bodasApi, urlReferido } from '../bodas/bodasUtils';

const copiar = async (texto) => {
  try { await navigator.clipboard.writeText(texto); toast.success('Enlace copiado'); }
  catch (e) { toast.error('No se pudo copiar. Mantén presionado el enlace para copiarlo.'); }
};

export default function TarjetaReferidos() {
  const [tarjeta, setTarjeta] = useState(null);

  useEffect(() => {
    bodasApi.miTarjeta().then(d => setTarjeta(d.tarjeta)).catch(() => setTarjeta(null));
  }, []);

  if (!tarjeta) return null;
  const url = urlReferido(tarjeta.codigo);
  const mensaje = `Te comparto mi enlace de Juan Pablo Murillo: con él tienes ${tarjeta.beneficio_valor}% de descuento en tu primera compra de sastrería a la medida. ${url}`;
  const compartir = async () => {
    if (navigator.share) {
      try { await navigator.share({ title: 'Juan Pablo Murillo', text: mensaje }); return; } catch (e) { if (e?.name === 'AbortError') return; }
    }
    window.open(`https://wa.me/?text=${encodeURIComponent(mensaje)}`, '_blank', 'noopener');
  };

  return (
    <div className="relative overflow-hidden rounded-2xl border border-[#C9A962]/30 bg-[#18181B] p-5 lg:p-6" data-testid="mi-jpm-tarjeta-referidos">
      <div className="flex items-center gap-2">
        <Gift className="h-5 w-5 text-[#C9A962]" />
        <span className="text-sm font-medium tracking-wider text-[#C9A962]">INVITA Y GANA</span>
      </div>
      <p className="mt-3 text-base leading-relaxed text-zinc-200">
        Comparte tu enlace personal: quien llegue por él recibe <strong className="text-white">{tarjeta.beneficio_valor}% de descuento</strong> en su primera compra,
        y tú ganas <strong className="text-white">{tarjeta.puntos_por_referido} Puntos JPM</strong> cuando compre.
      </p>
      <p className="mt-4 truncate rounded-xl border border-[#27272A] bg-black/40 px-4 py-3 font-mono text-sm text-zinc-300" data-testid="mi-jpm-enlace-referidos">{url}</p>
      <div className="mt-4 flex flex-col gap-2 sm:flex-row">
        <button type="button" onClick={compartir} className="inline-flex min-h-12 items-center justify-center gap-2 rounded-xl bg-[#C9A962] px-5 font-medium text-black transition-colors hover:bg-[#D4B872]" data-testid="mi-jpm-compartir-referidos">
          <Share2 className="h-4 w-4" />Compartir mi enlace
        </button>
        <button type="button" onClick={() => copiar(url)} className="inline-flex min-h-12 items-center justify-center gap-2 rounded-xl border border-[#3F3F46] px-5 font-medium text-zinc-200 transition-colors hover:bg-white/5" data-testid="mi-jpm-copiar-referidos">
          <Copy className="h-4 w-4" />Copiar enlace
        </button>
      </div>
    </div>
  );
}
